import { styled } from 'styled-components';

export const MapContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const Overlay = styled.div<{ $visible: boolean }>`
  display: ${(props) => (props.$visible ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 2000;
  justify-content: center;
  align-items: center;
`;

export const OverlayContent = styled.div`
  position: relative;
  max-width: 90%;
  max-height: 90%;
`;

export const OverlayImage = styled.img`
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  display: block;
`;

export const OverlayMetadata = styled.div<{ $status: string }>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  color: white;
  padding: 10px;
  font-family: monospace;
  font-size: 14px;
  background-color: ${(props) =>
    props.$status === 'selected'
      ? 'rgba(255, 0, 255, 0.5)'
      : props.$status === 'grow'
      ? 'rgba(0, 255, 0, 0.5)'
      : 'rgba(0, 0, 0, 0.3)'};
`;

export const OverlayCloseButton = styled.span`
  position: absolute;
  top: 20px;
  right: 30px;
  color: white;
  font-size: 40px;
  font-weight: bold;
  cursor: pointer;
  z-index: 2001;
`;
